module.exports = __webpack_public_path__ + "static/img/5.fa49433.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/3/sp/5.png
// module id = AqJv
// module chunks = 0